/*****************************************
* Slimmed down version of the original
* 
* Useful for new sites
******************************************/

if(typeof($) === 'undefined') {
   var $ = jQuery;
}

/*************************************************************************************
 * Browser Check
*************************************************************************************/
	var b = document.documentElement;
	b.className = b.className.replace('no-js', 'js');
	b.setAttribute("data-useragent", navigator.userAgent.toLowerCase());
	b.setAttribute("data-platform", navigator.platform.toLowerCase());

	var $html = $('html');
	var ua = ($html.data('useragent')),
		pf = ($html.data('platform'));


	function is(string) {
		return ua.indexOf(string) > -1
	}
	var browser = {
		isIE            : is('msie') || is('trident/7.0'),
		isIE7           : is('msie 7.0'),
		isIE8           : is('msie 8.0'),
		isIE9           : is('msie 9.0'),
		isIE10          : is('msie 10'),
		isIE11          : is('rv:11') && is('trident/7.0'),
		isEdge          : is('edge'),
		isChrome        : is('chrome') && !is('edge'),
		isSafari        : is('safari') && !is('chrome') && !is('edge'),
		isFirefox       : is('firefox') && !is('edge'),
		isAndroidChrome : is('android') && is('chrome'),
		isAndroidDefault: is('android') && !is('chrome'),
		isWin7          : is('windows nt 6.1'),
		isWin8          : is('windows nt 6.2'),
		isWindows       : pf.indexOf('win32') > -1,
		isWebkit        : is('webkit') && !is('edge'),
		isIPad          : is('ipad'),
		isIPadChrome    : is('ipad') && is('crios'),
		isIPhone        : is('iphone'),
		isIPhoneChrome  : is('iphone') && is('crios'),
		isAndroid       : is('android'),
		isIOS           : is('iphone') || is('ipad')
	}

	for (var title in browser) {
		var helperClass = title.slice(2).toLowerCase();
		if (browser[title]) {
			$html.addClass(helperClass);
		}
	}

// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;( function( $, window, document, undefined ) {

	"use strict";

		// undefined is used here as the undefined global variable in ECMAScript 3 is
		// mutable (ie. it can be changed by someone else). undefined isn't really being
		// passed in so we can ensure the value of it is truly undefined. In ES5, undefined
		// can no longer be modified.

		// window and document are passed through as local variables rather than global
		// as this (slightly) quickens the resolution process and can be more efficiently
		// minified (especially when both are regularly referenced in your plugin).

		// Create the defaults once
		var pluginName = "formWrapper",
			defaults = {
				pre: '',
				post: '-wrap',
				class: "wrapped",
				container: "div",
				types: {
					select: 'select:not([multiple])',
					radio: ':radio',
					checkbox: ':checkbox',
					file: ':file'
				}
			};

		// The actual plugin constructor
		function Plugin ( element, options ) {
			this.$element = $(element);

			// jQuery has an extend method which merges the contents of two or
			// more objects, storing the result in the first object. The first object
			// is generally empty as we don't want to alter the default options for
			// future instances of the plugin
			this.settings = $.extend( {}, defaults, options );
			this._defaults = defaults;
			this._name = pluginName;
			this.$wrapper = $("<"+this.settings.container+"/>");
			this.init();
		}

		// Avoid Plugin.prototype conflicts
		$.extend( Plugin.prototype, {
			init: function() {

				this.checkType();

				// Make sure the element is one of the specified types
				if ( this.type ) {
					this.wrap();
					this.$element.on('change.'+this._name, $.proxy( this.change, this ));
					this.$element.on('focus.'+this._name, $.proxy( this.focus, this ));
					this.$element.on('blur.'+this._name, $.proxy( this.blur, this ));
				}
			},

			// Removes the plugin data from the element and resets to default state
			remove: function() {
				this.unwrap();
				this.$element.off('change.'+this._name);
				this.$element.off('focus.'+this._name);
				this.$element.off('blur.'+this._name);
				$.data( this, "plugin_" + pluginName, '' );
			},

			// Return classes for the element wrapper
			getClasses: function() {
				var wrapClass = this.settings.pre + this.type + this.settings.post;

				switch ( this.type ) {
					case 'checkbox':
					case 'radio':
						if ( this.$element.prop('checked') ) {
							wrapClass += ' checked';
						}
						if ( this.$element.prop('disabled') ) {
							wrapClass += ' disabled';
						}
						break;

					case 'select':
						var $opt = this.$element.find('option:selected');
						if ( $opt.prop('disabled') ) {
							wrapClass += ' placeholder';
						}
						break;
				}

				return wrapClass;
			},

			// Remove the parent container from the element
			unwrap: function() {
				if ( this.$parent && this.$parent.length ) {
					var $clone = this.$element.clone();
					this.$parent.replaceWith( $clone );
					if ( this.type == "select" ) {
						var value = this.$element.val();
						$clone.val(value);
					}
				}
			},

			// Wrap the element in a styleable container
			wrap: function() {
				if ( this.type ) {
					this.$wrapper.addClass( this.getClasses() );
					this.$element.wrap( this.$wrapper );
					this.$parent = this.$element.parent();

					if ( this.type == 'select' ) {
						this.displaySelectOption();
					}

					if ( this.type == 'file' ) {
						this.displayFileName();
					}
				}
			},

			// Find the type of the element
			checkType: function() {
				var self = this;
				this.type = false;

				$.each(this.settings.types, function(k, v) {
					if ( self.$element.is(v) ) {
						self.type = k;
					}
				});
			},

			// Add a class to the element container
			focus: function( e ) {
				this.$parent.addClass('focused');
			},

			// Remove a class to the element container
			blur: function( e ) {
				this.$parent.removeClass('focused');
			},

			// Add/Remove classes based on change event of element
			change: function( e ) {
				if ( this.type ) {
					switch ( this.type ) {
						case 'checkbox':
							if ( this.$element.prop('checked') ) {
								this.$parent.addClass('checked');

							} else {
								this.$parent.removeClass('checked');
							}
							break;

						case 'radio':
							var name = this.$element.attr('name');

							if ( this.$element.prop('checked') ) {
								$('[name="'+name+'"]').parent().removeClass('checked');
								this.$parent.addClass('checked');
							}
							break;

						case 'select':
							this.displaySelectOption();
							this.$parent.removeClass('placeholder');
							break;

						case 'file':
							this.displayFileName();
							this.$parent.removeClass('placeholder');
							break;
					}
				}
			},

			// Display the Select value in a styleable tag
			displaySelectOption: function() {
				var $opt = this.$element.find('option:selected');
				var $ins = this.$element.siblings('ins');

				if ( $ins.length ) {
					$ins.html($opt.text());

				} else {
					$ins = '<ins>'+$opt.text()+'</ins>';
					this.$element.before($ins);
				}
			},

			// Display the File value in a styleable tag
			displayFileName: function() {
				var files = this.$element.get(0).files;
				var placeholder = this.$element.attr('placeholder') || 'No file chosen';
				var $ins = this.$element.siblings('ins');

				if ( files.length == 1 ) {
					placeholder = files[0].name;
				}

				if ( files.length > 1 ) {
					placeholder = files.length + ' files';
				}

				if ( $ins.length ) {
					$ins.html(placeholder);

				} else {
					this.$element.before('<ins>'+placeholder+'</ins>');
				}

			},
		} );

		// A really lightweight plugin wrapper around the constructor,
		// preventing against multiple instantiations
		$.fn[ pluginName ] = function( options ) {
			return this.each( function() {
				if ( options === 'remove' && $.data( this, "plugin_" + pluginName ) ) {
					var plugin = $.data( this, "plugin_" + pluginName );
					plugin.remove();

				} else if ( options !== 'remove' && !$.data( this, "plugin_" + pluginName ) ) {
					$.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
				}
			} );
		};

} )( jQuery, window, document );


/*************************************************************************************
 * Equal Height
 *
 * Thanks to CSS Tricks for pointing out this bit of jQuery
 *
 * It's been modified into a function called at page load
 * and then each time the page is resized. One large modification
 * was to remove the set height before each new calculation.
 *
 * http://css-tricks.com/equal-height-blocks-in-rows/
 *
 * @example - equalheight('.element, .element-2');
*************************************************************************************/
var equalheight = function(container){

	var currentTallest = 0,
		currentRowStart = 0,
		rowDivs = new Array(),
		$el,
		topPosition = 0;
	$(container).each(function() {

		$el = $(this);
		$($el).height('auto')
		topPostion = $el.position().top;

		if (currentRowStart != topPostion) {
			for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
				rowDivs[currentDiv].height(currentTallest);
			}
			rowDivs.length = 0; // empty the array
			currentRowStart = topPostion;
			currentTallest = $el.height();
			rowDivs.push($el);
		} else {
			rowDivs.push($el);
			currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
		}
		for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
			rowDivs[currentDiv].height(currentTallest);
		}
	});
};

function roundDownToAny(n, x) {
	x = x ? x : 5;
	return (Math.floor(n / x) * x);
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

$(document).ready(function(){
	// ********************************************************* //
	// Passive jQuery listener
	// A fix for the lighthouse error: Does not use passive listeners to improve scrolling performance
	jQuery.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
		}
	};
	jQuery.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
		}
	};
	jQuery.event.special.wheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("wheel", handle, { passive: true });
		}
	};
	jQuery.event.special.mousewheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("mousewheel", handle, { passive: true });
		}
	};
	
	$('select, :file, :radio, :checkbox').formWrapper();
});
